<template>
  <div v-if="item">
    <fields-list :item="item" :fields="fields" />
    <cards :id="id" />
    <div class="save-group">
      <button class="btn btn-warning btn-icon" @click="updateItem">
        <span class="ti-save"></span>{{ "save" | setText("Сохранить") }}
      </button>
    </div>
  </div>
</template>

<script>
import { cardUpdate, cardContent } from "@/plugins/functions";

export default {
  components: {
    cards: () => import("./Cards"),
  },
  data: () => ({
    cardLink: "clients",
    cardSetLink: "clients",
    item: null,
    fields: [
      {
        col: " col-12 col-md-6",
        key: "phone",
        labelKey: "phone",
        label: "Номер телефона",
        type: "field",
        textType: "text",
        readonly: true,
      },
      {
        col: " col-12 col-md-6",
        type: "field",
        key: "email",
        labelKey: "email",
        label: "Email",
      },
      {
        col: " col-12 col-md-6",
        key: "first_name",
        labelKey: "first_name",
        label: "Имя",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "last_name",
        labelKey: "last_name",
        label: "Фамилия",
        type: "field",
        textType: "text",
      },

      {
        col: " col-12 col-md-12",
        key: "birthday",
        labelKey: "birthday",
        label: "Дата рождения",
        type: "date",
        textType: "date",
      },

      {
        col: " col-12 col-md-6",
        key: "PINFL",
        labelKey: "PINFL",
        label: "ПИНФЛ",
        type: "field",
        textType: "text",
      },
      
      {
        col: " col-12 col-md-6",
        key: "family_name",
        labelKey: "family_name",
        label: "Отчество",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-12",
        key: "gender",
        labelKey: "gender",
        label: "Пол",
        type: "static_radio",
        items: [
          { id: "male", title: "Мужской" },
          { id: "fmale", title: "Женский" },
        ],
      },
      {
        col: " col-12 col-md-6",
        key: "PINFL",
        labelKey: "PINFL",
        label: "ПИНФЛ",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "INN",
        labelKey: "INN",
        label: "ИНН",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-12",
        key: "passport_prefix",
        labelKey: "passport_prefix",
        label: "Тип паспорта",
        type: "static_radio",
        items: [
          { id: "id", title: "ID" },
          { id: "old", title: "Обычный паспорт" },
        ],
      },
      {
        col: " col-12 col-md-6",
        key: "passport_1",
        labelKey: "passport_1",
        label: "Главное фото паспорта или ID",
        type: "img",
      },
      {
        col: " col-12 col-md-6",
        key: "passport_2",
        labelKey: "passport_2",
        label: "Фото прописки",
        type: "img",
      },
      {
        col: " col-12 col-md-6",
        key: "passport_3",
        labelKey: "passport_3",
        label: "Обратная сторона  ID",
        type: "img",
      },
      {
        col: " col-12 col-md-6",
        key: "passport_4",
        labelKey: "passport_4",
        label: "Селфи с паспортом или ID",
        type: "img",
      },
      {
        col: " col-12 col-md-6",
        key: "passport_number",
        labelKey: "passport_number",
        label: "Номер паспорта",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "passport_exp",
        labelKey: "passport_exp",
        label: "Срок паспорта",
        type: "date",
        textType: "date",
      },
      {
        col: " col-12 col-md-12",
        key: "passport_address",
        labelKey: "passport_address",
        label: "Адрес по прописке",
        type: "field",
        textType: "text",
      },
      {
        col: " col-12 col-md-6",
        key: "phone_additional",
        labelKey: "phone_additional",
        label: "Номер поручителя",
        type: "mask",
        mask: "+998#########",
        default: "+998",
      },
    ],
  }),

  props: ["id"],
  async created() {
    // this.pushLang();
    this.item = await this.cardContent(this.cardLink, this.id);
  },
  methods: {
    cardUpdate: cardUpdate,
    cardContent: cardContent,
    async updateItem() {
      let item = await this.cardUpdate(
        this.cardSetLink,
        this.item,
        this.fields
      );
      // if (item){
      //   this.item = item;
      // }
    },
  },
};
</script>
<style>
</style>
